export default __webpack_public_path__ + "static/media/dino_wating.dff6fa15.png";